import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import styles from 'components/transactionEditor/ActionButtons.module.css';
import { useTranslation } from 'react-i18next';
import BzmIcon from '../icons/BzmIcon';
import { PairSetItem } from './PairSetList';

interface PairSetProps {
  id: string;
  pairValues: PairSetItem;
  onChange: (name: string, value: string, id: string) => void;
  onDelete: () => void;
  onAdd: () => void;
  displayAdd: boolean;
  pairTitle: string;
  isReadOnly?: boolean;
}

const PairSet = (props: PairSetProps) => {
  const { t } = useTranslation('transactions');
  const handleChange = (e: any, id: string) => {
    const target = e.target as HTMLInputElement;
    props.onChange(target.name, target.value, id);
  };

  return (
    <Row id={props.id} className="mb-3">
      <Col md={5}>
        <Form.Group controlId={'qa-input-name-' + props.id}>
          <Form.Label>{t('transactions:processingActions.modal.pairName')}</Form.Label>
          <Form.Control
            disabled={props.isReadOnly}
            name="name"
            as="input"
            autoComplete={'off'}
            onChange={(event: any) => handleChange(event, props.id)}
            placeholder={t('transactions:processingActions.modal.pairName')}
            value={props.pairValues.name ? props.pairValues.name : ''}
          />
        </Form.Group>
      </Col>
      <Col md={5}>
        <Form.Group controlId={'qa-input-value-' + props.id}>
          <Form.Label>{t('transactions:processingActions.modal.pairValue')}</Form.Label>
          <Form.Control
            name="value"
            autoComplete={'off'}
            onChange={(event: any) => handleChange(event, props.id)}
            placeholder={t('transactions:processingActions.modal.pairValue')}
            value={props.pairValues.value ? props.pairValues.value : ''}
            disabled={props.isReadOnly}
          />
        </Form.Group>
      </Col>
      <Col md={2}>
        <div className={styles.actionButtons}>
          <Button
            disabled={props.isReadOnly}
            variant="danger"
            id={'qa-btn-delete-pair-' + props.id}
            onClick={props.onDelete}
            className="btn-circular"
            title={t('transactions:processingActions.modal.deletePair', { name: props.pairTitle })}
          >
            <BzmIcon variant={'icon-bzm-delete'} />
          </Button>
          {props.displayAdd && (
            <Button
              disabled={props.isReadOnly}
              variant="secondary"
              id={`qa-btn-add-pair-${props.pairTitle.toLowerCase().replace(' ', '-')}`}
              onClick={() => props.onAdd()}
              className="btn-circular ml-3"
              title={t('transactions:processingActions.modal.addNewPair', { name: props.pairTitle })}
            >
              <BzmIcon variant={'icon-bzm-add'} className={'icon-theme-blue'} />
            </Button>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default PairSet;
